import { addStepFunction, removeStepFunction } from "../shared/animate";
import React, { useState, useEffect } from "react";
import { getRandomInt, isVowel } from "../shared/util";
import doNotUseAccessibleStaticElementInteractions from "A11y/doNotUseAccessibleStaticElementInteractions";

import butterflyBlue from "./butterfly_blue.png";
import butterflyOrange from "./butterfly_orange.png";
import butterflyRed from "./butterfly_red.png";

const width = 160;
const height = 120;
const speed = 0.05;

const boundX = 700;
const boundY = 400;

const netX = 200;
const netY = 80;

export default function Letterfly(props) {
  const { id, grapheme, caught, hidden, disabled } = props;

  const [x, setX] = useState(0);
  const [y, setY] = useState(0);
  const [velX, setVelX] = useState(0.02);
  const [velY, setVelY] = useState(0.02);
  const [ready, setReady] = useState(false);

  // init position and velocity
  useEffect(() => {
    setX(getRandomInt(10, boundX - width - 10));
    setY(getRandomInt(10, boundY - height - 10));
    const angle = Math.random() * 2 * Math.PI;
    setVelX(speed * Math.cos(angle));
    setVelY(speed * Math.sin(angle));
    setReady(true);
  }, []);

  useEffect(() => {
    if (!ready) return;
    addStepFunction(id, (dt) => {
      if (dt > 100) return;
      setX(x + dt * velX);
      setY(y + dt * velY);

      if (caught) {
        // go to the net
        const dist = distance(x, netX, y, netY);
        const angle = Math.atan2(netY - y, netX - x);

        let vel = speed * 10;
        if (dist < 25) vel *= dist / 50;

        setVelX(vel * Math.cos(angle));
        setVelY(vel * Math.sin(angle));
      } else {
        // detect out of bounds
        if (width + x > boundX) setVelX(-1 * Math.abs(velX));
        if (height + y > boundY) setVelY(-1 * Math.abs(velY));
        if (x < 0) setVelX(Math.abs(velX));
        if (y < 0) setVelY(Math.abs(velY));
      }
    });
  });

  useEffect(() => {
    return () => {
      removeStepFunction(id);
    };
  });

  let src = butterflyBlue;
  if (isVowel(grapheme)) src = butterflyOrange;
  if (grapheme.length === 2) src = butterflyRed;

  const style = { ...props.style, left: x, top: y, opacity: 1 };
  if (hidden) style.opacity = 0;
  if (!disabled) style.cursor = "pointer";

  if (!ready) return null;
  return (
    <div className="letterfly" style={style} {...doNotUseAccessibleStaticElementInteractions({onClick: props.onClick})}>
      <img src={src} className="letterfly-img" alt="letterfly" />
      <div className="letterfly-grapheme">{grapheme}</div>
    </div>
  );
}

function distance(x1, x2, y1, y2) {
  const dy = y2 - y1;
  const dx = x2 - x1;
  return (dy ** 2 + dx ** 2) ** 0.5;
}
